/**
 * Merge strategies for combining default config with client overrides.
 * Direct port of ixconfig/merge.py (Python backend).
 */

/** Recursively merge override into base. Override wins on leaf conflicts. */
export function deepMerge(
    base: Record<string, unknown>,
    override: Record<string, unknown>
): Record<string, unknown> {
    const result = { ...base };
    for (const [key, value] of Object.entries(override)) {
        if (
            key in result &&
            typeof result[key] === 'object' &&
            result[key] !== null &&
            !Array.isArray(result[key]) &&
            typeof value === 'object' &&
            value !== null &&
            !Array.isArray(value)
        ) {
            result[key] = deepMerge(
                result[key] as Record<string, unknown>,
                value as Record<string, unknown>
            );
        } else {
            result[key] = value;
        }
    }
    return result;
}

/**
 * Apply named merge strategy.
 * - deep_merge: recursively merge override into base
 * - full_override: replace base entirely with override
 */
export function applyMergeStrategy(
    strategy: string,
    base: Record<string, unknown>,
    override: Record<string, unknown> | null | undefined
): Record<string, unknown> {
    if (override === null || override === undefined) {
        return base;
    }
    if (strategy === 'full_override') {
        return override;
    }
    return deepMerge(base, override);
}
